// extracted by mini-css-extract-plugin
export default {"fieldHeader":"fieldHeader__bmtZN","ptNone":"ptNone__11CiN"};